import React, { useState } from 'react';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  // Sample gallery items - replace with your actual images
  const galleryItems = [
    {
      id: 1,
      title: 'Blekinge Beach Map',
      description: 'Map showing the location of Blekinge beaches in Sweden.',
      imageUrl: 'images/badplatser.jpg', // Replace with actual image paths
      category: 'Maps'
    },
    {
      id: 2,
      title: 'France festival map',
      description: 'Map showing the location of festivals in France.',
      imageUrl: 'images/francefestival.jpg',
      category: 'Maps'
    },
    {
      id: 3,
      title: 'Love Song To A Stranger',
      description: 'An artistic representation of a love song to a stranger.',
      imageUrl: 'images/lovesongtoastranger.jpg',
      category: 'Art'
    },
  ];

  const categories = ['All', ...new Set(galleryItems.map(item => item.category))];
  const [activeCategory, setActiveCategory] = useState('All');

  const filteredItems = activeCategory === 'All' 
    ? galleryItems 
    : galleryItems.filter(item => item.category === activeCategory);

  return (
    <div style={{
      padding: '2rem',
      maxWidth: '1200px',
      margin: '0 auto',
      fontFamily: 'Arial, sans-serif',
      fontSize: '1.2rem',
    }}>
      <h1 style={{
        textAlign: 'center',
        color: '#B76E79',
        marginBottom: '2rem',
        fontSize: '3.5rem',
        textShadow: '1px 1px 10px rgba(175, 88, 88, 0)',
        fontFamily: 'Broadway, sans-serif',
        userSelect: 'none',
      }}>
        <span style={{ userSelect: 'none' }}>Map Gallery</span>
      </h1>

      {/* Category Filter */}
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        gap: '1rem',
        marginBottom: '2rem'
      }}>
        {categories.map(category => (
          <button
            key={category}
            onClick={() => setActiveCategory(category)}
            style={{
              padding: '0.5rem 1rem',
              background: activeCategory === category ? '#B76E79' : '#f8f1e5',
              color: activeCategory === category ? '#fff' : '#333',
              border: '2px solid #B76E79',
              borderRadius: '25px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              fontSize: '0.9rem',
              userSelect: 'none'
            }}
            onMouseEnter={(e) => {
              if (activeCategory !== category) {
                e.target.style.background = '#B76E79';
                e.target.style.color = '#fff';
              }
            }}
            onMouseLeave={(e) => {
              if (activeCategory !== category) {
                e.target.style.background = '#f8f1e5';
                e.target.style.color = '#333';
              }
            }}
          >
            <span style={{ userSelect: 'none' }}>{category}</span>
          </button>
        ))}
      </div>

      {/* Gallery Grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
        gap: '2rem',
        marginBottom: '2rem'
      }}>
        {filteredItems.map(item => (
          <div
            key={item.id}
            onClick={() => setSelectedImage(item)}
            style={{
              cursor: 'pointer',
              borderRadius: '12px',
              overflow: 'hidden',
              boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              background: 'white'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-5px)';
              e.target.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
            }}
          >
            <img
              src={item.imageUrl}
              alt={item.title}
              style={{
                width: '100%',
                height: '200px',
                objectFit: 'cover'
              }}
            />
            <div style={{
              padding: '1rem'
            }}>
              <h3 style={{
                margin: '0 0 0.5rem 0',
                color: '#333',
                fontSize: '1.1rem',
                userSelect: 'none'
              }}>
                <span style={{ userSelect: 'none' }}>{item.title}</span>
              </h3>
              <p style={{
                margin: '0',
                color: '#666',
                fontSize: '0.9rem',
                lineHeight: '1.4',
                userSelect: 'none'
              }}>
                <span style={{ userSelect: 'none' }}>{item.description}</span>
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Image Modal */}
      {selectedImage && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            padding: '1rem'
          }}
          onClick={() => setSelectedImage(null)}
        >
          <div
            style={{
              maxWidth: '90%',
              maxHeight: '90%',
              position: 'relative',
              background: 'white',
              borderRadius: '12px',
              padding: '2rem',
              boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setSelectedImage(null)}
              style={{
                position: 'absolute',
                top: '1rem',
                right: '1rem',
                background: 'white',
                border: '2px solid #B76E79',
                borderRadius: '50%',
                width: '30px',
                height: '30px',
                cursor: 'pointer',
                fontSize: '1.2rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              ×
            </button>
            <img
              src={selectedImage.imageUrl}
              alt={selectedImage.title}
              style={{
                maxWidth: '100%',
                maxHeight: '70vh',
                objectFit: 'contain',
                borderRadius: '8px'
              }}
            />
            <h2 style={{
              margin: '1rem 0 0.5rem 0',
              color: '#333',
              userSelect: 'none'
            }}>
              <span style={{ userSelect: 'none' }}>{selectedImage.title}</span>
            </h2>
            <p style={{
              margin: '0',
              color: '#666',
              userSelect: 'none'
            }}>
              <span style={{ userSelect: 'none' }}>{selectedImage.description}</span>
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;